module.exports = __webpack_public_path__ + "img/user-unknown.44ebf9cf.png";